import React from "react";

// component
import AlertPopup from "../../../Popup/AlertPopup";

const alertPopupExtendStyles = `
    margin: 33px auto 0 auto;
    left: 50%;
    transform: translate(-50%, 0);
    width: unset;
    max-width: unset;
`;

const ErrorStringDefault = ({ closePopup, children }) => {
    return (
        <AlertPopup
            type="ERROR"
            handleClickBtn={closePopup}
            extendStyles={alertPopupExtendStyles}
        >
            {children}
        </AlertPopup>
    );
};

export default ErrorStringDefault;
